$(document).ready(function(){
	
	// -- Homepage section services --
	var servicesSettings = {
		slidesToShow: 3,
		vertical: true,
		arrows: false,
		dots: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		centerMode: true,
		centerPadding: 0,
		rows: 0,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
		speed: 250,
	};
	$('.slider__services').slick(servicesSettings);

	// -- fix decallage --
	$(window).on('load resize orientationchange', function(){
		var maxHeight = -1;
		$('.slider__services .slick-slide').each(function() {
		  if ($(this).height() > maxHeight) {
		    maxHeight = $(this).height();
		  }
		});
		$('.slider__services .slick-slide').each(function() {
		  if ($(this).height() < maxHeight) {
		    $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
		  }
		});
	});




	// -- Block team --
	var teamSlider = $('.slider__team');
	var teamTextSelector = '.content, .content *';
	var enableTeamTextSelection = function($slider) {
		$slider.find(teamTextSelector).css({
			'user-select': 'text',
			'-webkit-user-select': 'text',
			'-moz-user-select': 'text',
			'-ms-user-select': 'text'
		});
	};

	var teamSettings = {
		adaptiveHeight: false,
		infinite: false,
		dots: false,
		appendArrows: $('.arrows__nav'),
		prevArrow: $('.arrows__nav .prev'),
		nextArrow: $('.arrows__nav .next'),
	};
	$('.slider__team').slick(teamSettings);

	// Allow selecting/copying text (emails) inside team cards without dragging the slider.
	teamSlider.on('mousedown touchstart pointerdown', teamTextSelector, function(event){
		event.stopPropagation();
	});

	teamSlider.on('init reInit setPosition', function(event, slick){
		enableTeamTextSelection($(slick.$slider));
	});

	enableTeamTextSelection(teamSlider);

	teamSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
	    var pos = (currentSlide) ? currentSlide + 1 : 1;
	    pos = (pos < 10) ? '0' + pos : pos;
	    $('.slide__position .position').text(pos);
	});

});
